<template>
  <div>
    <vs-card class="card_with_img_details mb-4">
      <div slot="header" class="flex flex-wrap justify-between items-center">
        <h4>Details</h4>
        <div class="inline-flex items-center">
          <vs-tooltip class="mr-2" color="primary" position="top" text="Status">
            <span
              style="min-width: 70px; min-height: 35px"
              class="cstm-status-badge"
              :class="getStatusName().toLowerCase()"
              >{{ getStatusName() }}</span
            >
          </vs-tooltip>
          <vs-tooltip color="primary" position="top" text="Download">
            <vs-button icon="download" type="border" @click="downloadCourseWork"></vs-button>
          </vs-tooltip>
        </div>
      </div>
      <div class="img_holder text-center">
        <span
          v-if="course_details.client_user.picture"
          class="b-avatar badge-light-danger rounded"
          style="width: 150px; height: 104px"
        >
          <img :src="course_details.client_user.picture" alt="avatar" />
        </span>
        <svg
          v-else
          style="width: 100px; height: 50px; object-fit: contain;"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="user-circle"
          class="svg-inline--fa fa-user-circle fa-w-16"
          role="img"
          viewBox="0 0 496 512"
        >
          <path
            fill="currentColor"
            d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
          />
        </svg>
        <h4 class="mt-3">
          {{ course_details.client_user.first_name }}
          {{ course_details.client_user.last_name }}
        </h4>
      </div>
      <div class="content_holder">
        <vs-row>
          <vs-col vs-lg="6" vs-sm="12">
            <vs-row>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <feather-icon icon="BookIcon" />
                <b class="pr-2">Name: </b>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <div>{{ course_details.assignment_builder.title }}</div>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <feather-icon icon="BookIcon" />
                <b class="pr-2">Subject: </b>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <div>
                  {{
                    course_details.assignment_builder.has_all_subject
                      ? "General"
                      : subject
                  }}
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <feather-icon icon="HelpCircleIcon" />
                <b class="pr-2">No. of Questions: </b>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <div>{{ course_details.no_of_questions }}</div>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <feather-icon icon="CheckCircleIcon" />
                <b class="pr-2">Available Marks: </b>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <div>{{ course_details.total_marks }}</div>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-lg="6" vs-sm="12">
            <vs-row>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <feather-icon icon="CheckSquareIcon" />
                <b class="pr-2">Obtained Marks: </b>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <div>
                  {{
                    course_details.obtained_marks
                      ? course_details.obtained_marks
                      : "Not Available"
                  }}
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <feather-icon icon="PercentIcon" />
                <b class="pr-2">Percentage: </b>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <div>
                  {{
                    course_details.percentage
                      ? course_details.percentage
                      : "Not Available"
                  }}
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <feather-icon icon="CalendarIcon" />
                <b class="pr-2">Received: </b>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <div>
                  {{
                    course_details.submitted_on
                      ? $moment(Date.parse(course_details.submitted_on)).format(dateTimeFormat)
                      : "Not Available"
                  }}
                </div>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <feather-icon icon="CalendarIcon" />
                <b class="pr-2">Deadline: </b>
              </vs-col>
              <vs-col vs-type="flex" vs-align="center" vs-lg="6" class="p-1">
                <div>
                  {{
                    course_details.assignment_builder.deadline
                      ? $moment(Date.parse(course_details.assignment_builder.deadline)).format(dateTimeFormat)
                      : "Not Available"
                  }}
                </div>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>

    <!-- question and answer -->
    <vs-card class="question_card">
      <div slot="header" class="flex flex-wrap justify-between items-center">
        <h4>Worksheet</h4>
      </div>
      <div>
        <div
          class="light-border p-4 my-2"
          v-for="(question, index) in course_details.assignment_builder
            .questions"
          :key="index"
        >
          <div class="flex flex-wrap justify-between items-center mb-4">
            <div class="inline-flex w-4/5">
              <b style="vertical-align: top" class="pr-2"
                >Q.{{ index + 1 }})
              </b>
              <p class="question-container w-full mb-0">
                {{ question.title }}
              </p>
            </div>
            <p class="inline-flex items-center font-bold ml-auto">
              Marks:
              <vs-input
                onkeypress="return (event.charCode >= 48)"
                @keyup="checkMark($event, question.point, index)"
                style="width: 60px; margin-left: 5px"
                :color="[marks_error ? 'danger' : 'success']"
                :max="question.point"
                min="0"
                type="number"
                v-model="question.student_answers.mark"
              />
              <span>/</span>
              <vs-input
                readonly
                style="width: 60px; margin-left: 5px"
                type="number"
                v-model="question.point"
              />
            </p>
          </div>
          <vs-textarea
            v-if="
              question.question_input_type_id === 1 ||
                question.question_input_type_id === 2
            "
            readonly
            label="Write your answer here"
            v-model="question.student_answers.short_answer"
          />
          <div v-if="question.question_input_type_id === 3">
            <div
              class="options-holder"
              v-for="(options, index) in question.questions_options"
              :key="index"
            >
              <vs-radio
                disabled
                v-model="question.student_answers.assignment_question_answer_id"
                :name="`custom${index}`"
                :vs-value="options.id"
                :ref="`custom${index}`"
              >
                <p>
                  <span>{{ options.option_name }}</span>
                  <!-- <span>
                    <img
                      class="answer_validation_icon"
                      src="../../../../../src/assets/images/pages/courses/QA_Icon/correct.png"
                      v-if="options.is_answer"
                    />
                  </span>
                  <span>
                    <img
                      class="answer_validation_icon"
                      src="../../../../../src/assets/images/pages/courses/QA_Icon/incorrect.png"
                      v-if="
                        !options.is_answer &&
                        checkifSelected(
                          question.question_input_type.field_type,
                          question.questions_answers,
                          options.id
                        )
                      "
                    />
                  </span> -->
                </p>
              </vs-radio>
            </div>
          </div>
          <div
            v-if="
              question.question_input_type_id === 4 ||
                question.question_input_type_id === 6
            "
          >
            <div
              class="options-holder"
              v-for="(options, index) in question.questions_options"
              :key="index"
            >
              <vs-checkbox
                disabled="true"
                v-model="question.student_answers.assignment_question_answer_id"
                :vs-value="options.id"
                :ref="`custom${index}`"
              >
                <p>
                  <span>{{ options.option_name }}</span>
                  <!-- <span>
                    <img
                      class="answer_validation_icon"
                      src="../../../../../src/assets/images/pages/courses/QA_Icon/correct.png"
                      v-if="options.is_answer"
                    />
                  </span>
                  <span>
                    <img
                      class="answer_validation_icon"
                      src="../../../../../src/assets/images/pages/courses/QA_Icon/incorrect.png"
                      v-if="
                        !options.is_answer &&
                        checkifSelected(
                           question.question_input_type.field_type,
                          question.questions_answers,
                          options.id
                        )
                      "
                    />
                  </span> -->
                </p>
              </vs-checkbox>
              <br />
            </div>
          </div>
          <div v-if="question.question_input_type_id === 5">
            <v-select
              disabled
              class="options-holder"
              v-model="question.student_answers.assignment_question_answer_id"
              :name="`custom${index}`"
              :options="question.questions_options"
              :reduce="option => option.id"
              label="option_name"
            />
          </div>
          <file-upload-component
            v-if="question.question_input_type_id === 7"
            :files_info="question.answer ? question.answer : []"
          ></file-upload-component>
          <vs-divider />
          <!-- feedback -->
          <div class="flex">
            <b class="pr-2">Feedback:</b>
            <vs-textarea
              class="w-full"
              style="margin-left: 5px;"
              type="text"
              v-model="question.student_answers.teacher_comment"
            />
          </div>
        </div>
      </div>
      <vs-button
        @click="submitFeedback"
        v-if="course_details.teacher_status == 2"
        >Submit</vs-button
      >
    </vs-card>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { repository } from '@/mixins/repository.js'

import FileUploadComponent from '@/views/pages/classes/components/FileUploadComponent'

import { fetchCustomerList, submitMarks, downloadCourseWorkPdf } from '@/api/course-work'
import axios from 'axios'

export default {
  components: {
    vSelect,
    FileUploadComponent
  },
  mixins: [repository],
  mounted () {
    this.customer_id = localStorage.getItem('customer_id')
    this.client_user = this.$route.params.client_user
    this.assignment_builder_user_id = this.$route.params.assignment_builder_user_id
    this.assignment_type_id = this.$route.params.assignment_type_id
    this.fetchCourseWorkDetails()
    // this.course_details = this.$route.params.course_details

    this.subjects = this.course_details.assignment_builder.subject.map(e => {
      if (e.subject_name) {
        return e.subject_name
      }
    })
    this.subjects = this.subjects.join(', ')
  },
  computed: {},
  data () {
    return {
      assignment_type_id: '',
      dateTimeFormat: `${JSON.parse(localStorage.getItem('localization')).date_format} ${JSON.parse(localStorage.getItem('localization')).time_format}`,
      statusArray: [
        {
          id: 1,
          status: 'Assigned'
        },
        {
          id: 2,
          status: 'Received'
        },
        {
          id: 3,
          status: 'Marked'
        },
        {
          id: 4,
          status: 'Completed'
        },
        {
          id: 5,
          status: 'Delayed'
        }
      ],
      course_details: null,
      subjects: null,
      customer_id: null,
      client_user: null,
      assignment_builder_user_id: null,
      marks_error: false
    }
  },
  methods: {
    checkMark (e, data, index) {
      if (e.target.value > data) {
        this.course_details.assignment_builder.questions[
          index
        ].student_answers.mark = null
        this.marks_error = true
      } else {
        this.marks_error = false
      }
      console.log(this.course_details.assignment_builder.questions)
    },
    getStatusName () {
      return this.statusArray[this.course_details.teacher_status - 1].status
    },
    async submitFeedback () {
      try {
        let payload = []
        payload = this.course_details.assignment_builder.questions.map(ele => {
          console.log(ele)
          return {
            student_answer_id: ele.answer,
            mark: ele.student_answers.mark,
            teacher_comment: ele.student_answers.teacher_comment,
            assignment_type_id: this.assignment_type_id
          }
        })
        if (payload.length) {
          this.saveAnswerMarks(payload)
        }
      } catch (e) {}
    },
    async saveAnswerMarks (payload) {
      try {
        const Mark = {
          marks: payload
        }
        const { data } = await submitMarks(
          this.customer_id,
          this.assignment_builder_user_id,
          Mark
        )
        console.log(data)
        const successMessage = ''

        this.$vs.notify({
          title: 'Success',
          text: 'Marks Submitted successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        if (this.assignment_type_id == 2) {
          this.$router.push({
            name: 'Coursework'
          })
        } else {
          this.$router.push({
            name: 'Exam'
          })
        }
      } catch (error) {
        console.log(error)
        this.$vs.notify({
          title: 'error',
          text: 'Something Went Wrong',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          time: 3000
        })
      }
    },
    setQuestionModalAnswer () {
      console.log(this.course_details.assignment_builder.questions)
      this.course_details.assignment_builder.questions.forEach(ele => {
        this.$set(ele, 'marks', ele.marks ? ele.marks : null)
        if (
          ele.question_input_type_id == 3 ||
          ele.question_input_type_id == 5
        ) {
          ele.Questiontype = 'radio'
          this.$set(
            ele,
            'answer',
            ele.student_answers.id ? ele.student_answers.id : null
          )
        } else if (
          ele.question_input_type_id == 4 ||
          ele.question_input_type_id == 6
        ) {
          ele.Questiontype = 'multiselect'
          this.$set(
            ele,
            'answer',
            ele.student_answers.id ? ele.student_answers.id : []
          )
        } else if (ele.question_input_type_id == 7) {
          ele.Questiontype = 'fileupload'
          this.$set(
            ele,
            'answer',
            ele.student_answers.files.length > 0
              ? ele.student_answers.files
              : []
          )
        } else {
          this.$set(
            ele,
            'answer',
            ele.student_answers.id ? ele.student_answers.id : null
          )
          ele.Questiontype = 'shortanswer'
        }
      })
    },
    async fetchCourseWorkDetails () {
      const payload = {
        custom: 0,
        assignment_type_id: this.assignment_type_id,
        client_user_id: this.client_user
      }
      const { data } = await fetchCustomerList(
        this.customer_id,
        this.assignment_builder_user_id,
        payload
      )
      this.course_details = data.data.courseWork
      console.log('fdfdfd')
      console.log(this.course_details)

      const subjectseparation = this.course_details.assignment_builder.subject.map(
        e => {
          if (e.subject_name) {
            return e.subject_name
          }
        }
      )
      this.subject = subjectseparation.join(', ')
      this.assignment_type_id = this.course_details.assignment_type_id
      this.setQuestionModalAnswer()
    },
    async downloadCourseWork () {
      const payload = {
        student_answer: this.course_details.teacher_status !== 1
      }
      const { data } = await downloadCourseWorkPdf(
        this.customer_id,
        this.assignment_builder_user_id,
        payload
      )
      this.downloadItem({
        url: data.data.url,
        label: data.data.name
      })
    },
    downloadItem ({ url, label }) {
      axios
        .get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'mime' })
          // const blob = new Blob([response.data], { type: 'application/pdf' })

          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${label}.${
            url.split('.')[url.split('.').length - 1]
          }`
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    }
  }
}
</script>
